import { ListingsPage } from "@/pages/Listings";

export default function OfficeListings() {
  return (
    <ListingsPage
      type="office"
      overline="RE/MAX Performance Realty"
      title="Office Listings"
      subtitle="A broader selection of listings from across the RE/MAX Performance Realty office. Live brokerage feed integration is pending confirmation with the brokerage."
      emptyText="Office listings are being prepared. The full brokerage feed will appear here once confirmed."
      seoTitle="Office Listings | RE/MAX Performance Realty — Mike Sidhu, Personal Real Estate Corporation"
      seoDescription="Explore listings from across the RE/MAX Performance Realty office in British Columbia, presented by Mike Sidhu, Personal Real Estate Corporation."
      seoPath="/office-listings"
    />
  );
}
